import { render, staticRenderFns } from "./StartChat.vue?vue&type=template&id=f5cc68c0&scoped=true"
import script from "./StartChat.vue?vue&type=script&lang=js"
export * from "./StartChat.vue?vue&type=script&lang=js"
import style0 from "./StartChat.vue?vue&type=style&index=0&id=f5cc68c0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cc68c0",
  null
  
)

export default component.exports